import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiPaginationResponse, ApiResponse } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  AddEecsCancellationPayload,
  FetchEecsCancellationsPayload,
  IEecsCancellation,
} from '../types/eecs-cancellations.types';

export const eecsCancellationsApi = createApi({
  reducerPath: 'eecsCancellationsApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/eecs/cancellations`),
  endpoints: (builder) => ({
    fetchCancellations: builder.query<ApiPaginationResponse<IEecsCancellation[]>, FetchEecsCancellationsPayload>({
      query: (payload) => ({
        url: ``,
        method: 'GET',
        params: payload,
      }),
    }),
    addCancellation: builder.query<ApiResponse<IEecsCancellation>, AddEecsCancellationPayload>({
      query: (payload) => ({
        url: ``,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const { useLazyFetchCancellationsQuery, useLazyAddCancellationQuery } = eecsCancellationsApi;
